import ThreeDotTyping from "@assets:three_dot_typing_lottie.json";
import Lottie from "lottie-react";

export const AILoading = () => {
  return (
    <Lottie
      animationData={ThreeDotTyping}
      loop
      style={{
        height: 30,
        width: 40,
      }}
    />
  );
};
